import { Product } from "components"

import panda from "media/images/antivirusImage/panda.png"
import pandaWebP from "media/images/antivirusImage/panda.webp"

import kaspersky from "media/images/antivirusImage/kaspersky.png"
import kasperskyWebP from "media/images/antivirusImage/kaspersky.webp"

import fSecure from "media/images/antivirusImage/f-secure.png"
import fSecureWebP from "media/images/antivirusImage/f-secure.webp"

const products: Product[] = [
	{
		color: "amethyst",
		text: "آنتی ویروس پاندا",
		link: "/shop/panda",
		image: panda,
		webP: `${pandaWebP} 1x`,
	},
	{
		color: "teal",
		text: "آنتی ویروس کسپرسکی",
		link: "/shop/kaspersky",
		image: kaspersky,
		webP: `${kasperskyWebP} 1x`,
	},
	{
		color: "aqua-blue",
		text: "آنتی ویروس اف-سکیور",
		link: "/shop/f-secure",
		image: fSecure,
		webP: `${fSecureWebP} 1x`,
	},
]

export { products }
